import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BoDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getVersion(lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/ws_getVersion', item, options);
  }

  public getSocketChannels(context, lang,  udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/access/ws_myChannelList', item, options);
  }
}
